/**
 * Kill switch for the Google Business Profile integration (and the Media
 * Manager surface built on it). Set to `false` to hide the Integrations card,
 * the Marketing → Media Manager page, and the Control Centre rating badge.
 *
 * GBP now runs through Ayrshare (was Zernio).
 */
export const GBP_ENABLED = true;

/**
 * Kill switch for Facebook, Instagram, and LinkedIn connect (Ayrshare).
 * Automate cards and Integrations tiles respect this flag.
 */
export const SOCIAL_ENABLED = true;

/**
 * EXPERIMENT: on mobile, collapse the bottom-right floating action buttons
 * (AI voice, messages, control centre, create) into a single bottom bar, and
 * reserve space for it so page content renders between the header and the bar.
 *
 * Set to `false` to restore the stacked floating buttons everywhere — nothing
 * else needs touching, and `--bottom-nav-height` collapses back to 0px.
 */
export const MOBILE_BOTTOM_BAR = true;

/** Height of the mobile bottom bar (excluding the iOS home-indicator inset). */
export const MOBILE_BOTTOM_BAR_HEIGHT_REM = 3.5;
